var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0237 2.16669H6.94449C4.31199 2.16669 2.16699 4.31169 2.16699 6.94419V13.9859V14.2025C2.16699 16.8459 4.31199 18.98 6.94449 18.98H11.1045C11.7003 18.98 12.1878 19.4675 12.1878 20.0634V21.1142C12.1878 21.71 11.7003 22.1975 11.1045 22.1975H8.48283C8.03866 22.1975 7.67033 22.5659 7.67033 23.01C7.67033 23.4542 8.02783 23.8334 8.48283 23.8334H17.5287C17.9728 23.8334 18.3412 23.465 18.3412 23.0209C18.3412 22.5767 17.9728 22.2084 17.5287 22.2084H14.907C14.3112 22.2084 13.8237 21.7209 13.8237 21.125V20.0742C13.8237 19.4784 14.3112 18.9909 14.907 18.9909H19.0345C21.6778 18.9909 23.812 16.8459 23.812 14.2134V13.9967V6.95502C23.8012 4.31169 21.6562 2.16669 19.0237 2.16669Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.7ffc182608a033f9aa91d704075183b3.svg";
export { ForwardRef as ReactComponent };